export default {
  // パンくずリスト
  breadcrumb: {
    projectSettings: '設定',
    interviewSettings: '選考設定',
    interviewProcess: '選考フロー',
    createProcess: '選考フロー作成',
    editProcess: '選考フロー編集',
  },

  // リストページ
  pageTitle: '選考フロー',
  searchPlaceholder: '選考フロー名を検索',
  createProcess: '選考フロー作成',
  processName: '選考名',
  employmentType: '雇用形態',
  selectionProcess: '選考フロー',
  processDescription: '選考フローの説明',
  isEnabled: '有効/無効',
  lastEditTime: '最終更新日時',
  lastEditor: '最終更新者',
  createTime: '作成日時',
  creator: '作成者',
  enabled: '有効',
  disabled: '無効',

  // 詳細ページ
  createTitle: '選考フロー作成',
  editTitle: '選考フロー編集',
  basicInfo: '基本情報',
  processNamePlaceholder: '入力してください',
  employmentTypePlaceholder: '選択してください',
  processDescriptionPlaceholder: '入力してください',
  processFlow: '選考フロー',

  // 選考段階
  resumeScreening: '書類選考',
  interview: '面接',
  offer: '内定',
  onboarding: '入社',
  other: 'その他',

  // 選考段階フィールド
  stageName: '選考プロセス',
  stageType: '選考内容の説明',
  evaluationTemplate: '評価模板',
  addInterview: '面接を追加',

  // プレースホルダー
  stageNamePlaceholder: '入力してください',
  stageTypePlaceholder: '選択してください',
  evaluationTemplatePlaceholder: '選択してください',

  // 評価テンプレートオプション（一時的に固定）
  defaultTemplate: 'デフォルトテンプレート',
  technicalTemplate: '技術面接テンプレート',
  hrTemplate: 'HR面接テンプレート',

  // 雇用形式オプション
  fullTime: '正社員',
  contract: '契約社員',

  // 検証メッセージ
  processNameRequired: '選考フロー名称を入力してください',
  employmentTypeRequired: '雇用形式を選択してください',
  stageNameRequired: '選考プロセスを入力してください',
  stageTypeRequired: '選考内容の説明を選択してください',
  evaluationTemplateRequired: '評価模板を選択してください',
  processNameDuplicate: '入力された選考フロー名はすでに登録済みです',
  stageNameDuplicate: '入力された選考プロセス名はすでに登録済みです',

  // 削除確認
  deleteConfirmTitle: '選考フロー削除',
  deleteConfirmContent: '削除すると元に戻せません。選考フロー「 {name}」を削除してよろしいですか？',
  deleteNotAllowedTitle: '選考フロー削除',
  deleteNotAllowedContent: 'この選考フローを使用している職位があるため、現在は削除できません。',

  // 有効化/無効化確認
  enableConfirmTitle: '選考フローを有効にする',
  enableConfirmContent: '有効にすると、新規求人を作成する際にこの選考フローを選択できるようになります。',
  disableConfirmTitle: '選考フローを無効にする',
  disableConfirmContent: '無効にすると、新規求人を作成する際にはこの選考フローを選択できなくなりますが、すでにこの選考フローを運用中の求人には影響しません。',

  // 有効状態の説明
  enabledDescription: '有効にしているため、新規作成ポジションで本選考フローを選択可能',
  disabledDescription: '無効のため、求人作成する際にはこの選考フローを選択できません。',

  // 空状態
  emptyStates: {
    noData: {
      title: '選考フローがありません',
      description: '選考フロー作成してください',
    },
  },
  btnEnable: '有効',
  btnDisable: '無効',
};
